import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError, IPaginationRequest, IPaginationResponse } from 'api/types';

export interface IPanelKnowledgeBaseItem {
  id: number;
  symbol: string;
  title: string;
  image: string | null;
}

type IRequest = IPaginationRequest;
type IResponse = IPaginationResponse<IPanelKnowledgeBaseItem>;

const getPanelKnowledgeBase = (params?: IRequest): Promise<IResponse> =>
  axios.get('/panel/knowledge-base', { params });

export const useGetPanelKnowledgeBase = (
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['panel-knowledge-base', params],
    () => getPanelKnowledgeBase(params),
    options
  );
